require('./mortgageRequestEstatesSuccessful.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { includes, chain, filter, map } = require('lodash');
const classnames = require('classnames');

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const propertyIdentification = require('./propertyIdentification');

// // @ commons
const { formatText, getLanguage } = require('core/i18n').i18n;
const { addOrdinal } = require('utilities/stringHelper');

// @ actions
const { requestSelectsData } = require('actions/mortgageRequest/mortgageRequestLocationData');
const { resetInmuebles } = require('actions/mortgageRequest/mortgageRequestInmuebles');
const { getEstatesData } = require('actions/mortgageRequest/mortgageRequestEstates');
const { resetLocationData } = require('actions/mortgageRequest/mortgageRequestLocationData');

// @ constants
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');
const { NS_RESULT } = require('constants/mortgageRequestPanelStates');

class MortgageRequestEstatesSuccessful extends React.Component {
    componentWillMount() {
        if (!this.props.estatesState.get('dataSaved')) {
            this.props.history.push('/myprofile/mortgage/panel');
        } else {
            this.props.getEstatesDataAction();
        }
    }

    componentWillUnmount() {
        this.props.resetInmueblesAction();
        this.props.resetLocationDataAction();
    }

    setInfo() {
        const { inmueblesState, mortgageState } = this.props;

        const data = inmueblesState.get('list').toJS();

        this.hasNSResult = includes(NS_RESULT, mortgageState.get('estado'));

        this.livingPlaceData = chain(data).filter(estate => estate.propertyType === ESTATES_TYPE_ABBREVIATION.VIVIENDA).last().value();

        this.garagesData = filter(data, estate => estate.propertyType === ESTATES_TYPE_ABBREVIATION.GARAJE);

        this.storageRoomsData = filter(data, estate => estate.propertyType === ESTATES_TYPE_ABBREVIATION.TRASTERO)

        this.infoSetted = true;
    }

    buildCenter() {
        return (
            <div className="row mortgage-request-estates-result-successful">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-10 col-xs-offset-2">
                            {this.buildPanels()}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-10 col-xs-offset-2">
                            <div className="mortgage-request-estates-result-successful__messages">
                                <p>{formatText('mortgageRequestEstatesSuccessfulResult-message1')}</p>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildEstateRow(type, data, idx) {

        const title = type === 'T' ? formatText('mortgageRequestEstatesSuccessfulResult-storageRoom') : formatText('mortgageRequestEstatesSuccessfulResult-garage');

        const ordinal = addOrdinal(getLanguage(), parseInt(idx, 10) + 1);

        const rowClassNames = classnames('row', {
            'mortgage-request-estates-result-successful-living-place--margin-top': idx === 0
        });

        return (
            <div className={rowClassNames} key={`${type}${idx}`}>
                <div className="col-xs-12">
                    <span className="mortgage-request-estates-result-successful-living-place__title">{ordinal} {title}</span>
                    <span className="mortgage-request-estates-result-successful-living-place__value">
                        {propertyIdentification(data, this.hasNSResult)}
                    </span>
                </div>
            </div>
        );
    }

    buildHeader() {
        return (
            <div className="row">
                <div className="col-xs-2">
                    <i className="mortgage-request-estates-result-successful-view__success-icon" />
                </div>
                <div className="col-xs-10">
                    <OKBoxTitle
                        value={formatText('mortgageRequestEstatesSuccessfulResult-mainTitle')}
                    />
                </div>
            </div>
        );
    }

    buildLeftPanel() {
        return (
            <div className="col-xs-6">
                <div className="row">
                    <div className="col-xs-12">
                        <span className="mortgage-request-estates-result-successful-living-place__title">
                            {formatText('mortgageRequestEstatesSuccessfulResult-livingPlaceLabel')}
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        {propertyIdentification(this.livingPlaceData, this.hasNSResult)}
                    </div>
                </div>
            </div>
        );
    }

    buildLinks() {
        return (
            <div className="row">
                <div className="col-xs-10 col-xs-offset-2">
                    <div className="pull-right">
                        <OKLink
                            modifier="complementary"
                            to="/myprofile/mortgage/panel"
                        >
                            {formatText('mortgageRequestEstatesSuccessfulResult-backToPanelText')}
                        </OKLink>
                    </div>
                    <div className="pull-right mortgage-request-estates-result-successful__separator--right">
                        <OKLink
                            modifier="complementary"
                            to="/myprofile/mortgage/estates"
                        >
                            {formatText('mortgageRequestEstatesSuccessfulResult-updateValues')}
                        </OKLink>
                    </div>
                    <div className="pull-right mortgage-request-estates-result-successful__separator--right">
                        <OKLink
                            modifier="complementary"
                            to="/myprofile/mortgage/simple-note"
                        >
                            {formatText('mortgageRequestEstatesSuccessfulResult-uploadSNText')}
                        </OKLink>
                    </div>
                </div>
            </div>
        );
    }

    buildPanels() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        {this.buildLeftPanel()}
                        {this.buildRightPanel()}
                    </div>
                    <div className="row">
                        <div className="col-xs-12 mortgage-request-estates-result-successful__separator">
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildRightPanel() {
        const storageRoomsIncluded = parseInt(this.livingPlaceData.storageRooms) || 0;
        const garagesIncluded = parseInt(this.livingPlaceData.garages) || 0;

        const storageRoomsIncludedRow = storageRoomsIncluded !== 0 && (
            <div className="row">
                <div className="col-xs-12">
                    <span className="mortgage-request-estates-result-successful-living-place__value">
                        {formatText('mortgageRequestEstatesSuccessfulResult-storageRoomCount', [storageRoomsIncluded])}
                    </span>
                </div>
            </div>
        );

        const garagesIncludedRow = garagesIncluded !== 0 && (
            <div className="row">
                <div className="col-xs-12">
                    <span className="mortgage-request-estates-result-successful-living-place__value">
                        {formatText('mortgageRequestEstatesSuccessfulResult-garageCount', [garagesIncluded])}
                    </span>
                </div>
            </div>
        );

        const storageRoomsGaragesIncluded = (storageRoomsIncluded !== 0 || garagesIncluded !== 0) && (
            <div className="row">
                <div className="col-xs-12">
                    <span className="mortgage-request-estates-result-successful-living-place__title">
                        {formatText('mortgageRequestEstatesSuccessfulResult-includedLabel')}
                    </span>
                    {storageRoomsIncludedRow}
                    {garagesIncludedRow}
                </div>
            </div>
        );

        const storageRoomsList = map(this.storageRoomsData, (storageRoom, idx) => this.buildEstateRow('T', storageRoom, idx));
        const garagesList = map(this.garagesData, (garage, idx) => this.buildEstateRow('G', garage, idx));

        return (
            <div className="col-xs-6 mortgage-request-estates-result-successful__other-properties">
                {storageRoomsGaragesIncluded}
                {storageRoomsList}
                {garagesList}
            </div>
        );
    }

    render() {
        const { inmueblesState, locationDataState, requestSelectsDataAction } = this.props;

        if (inmueblesState.get('list').isEmpty() || !inmueblesState.get('hasBeenFetched')) {
            return <LoadingSection />;
        } else if (!locationDataState.get('allEditSelectsLoaded')) {
            this.selectsDataRequested || requestSelectsDataAction();
            this.selectsDataRequested = true;
            return <LoadingSection />;
        }

        this.infoSetted || this.setInfo();

        return (
            <ContentBox>
                {this.buildHeader()}
                {this.buildCenter()}
                {this.buildLinks()}
            </ContentBox>
        );
    }
}


MortgageRequestEstatesSuccessful.propTypes = {
    data: PropTypes.object
}

module.exports = MortgageRequestEstatesSuccessful;

module.exports.constructor = MortgageRequestEstatesSuccessful;

MortgageRequestEstatesSuccessful.propTypes = {
    history: PropTypes.object.isRequired,
    inmueblesState: PropTypes.object,
    estatesState: PropTypes.object,
    locationDataState: PropTypes.object,
    mortgageState: PropTypes.object,
    requestSelectsDataAction: PropTypes.func,
    resetInmueblesAction: PropTypes.func,
    resetLocationDataAction: PropTypes.func,
    getEstatesDataAction: PropTypes.func,
};

module.exports.MortgageRequestEstatesSuccessful = connect(state => ({
    estatesState: state.mortgageRequestEstates,
    inmueblesState: state.mortgageRequestInmuebles,
    locationDataState: state.mortgageRequestLocationData,
    mortgageState: state.mortgageRequestState,
}), {
        requestSelectsDataAction: requestSelectsData,
        resetInmueblesAction: resetInmuebles,
        getEstatesDataAction: getEstatesData,
        resetLocationDataAction: resetLocationData,
    })(withRouter(MortgageRequestEstatesSuccessful));
